module.exports = __webpack_public_path__ + "static/media/product5.f908860c.jpg";